export default __webpack_public_path__ + "static/1-53477f31cbe0f863cd62cb144cdf8df3.mp4";